import {NgModule} from '@angular/core';
import {SharedModule} from "../../../shared.module";
import {CartProductSummaryModule} from "../cart-product-summary/cart-product-summary.module";
import {CartOverviewComponent} from "./cart-overview.component";
import {CartSavedProductModule} from "../cart-saved-product/cart-saved-product.module";
import {AoUpsellModule} from "../../ao-cart/ao-upsell/ao-upsell.module";
import {InitialOrderRewardModule} from "../../ao-cart/initial-order-bonus/initial-order-reward.module";

@NgModule({
    imports: [
        AoUpsellModule,
        CartProductSummaryModule,
        CartSavedProductModule,
        InitialOrderRewardModule,
        SharedModule,
    ],
    declarations: [CartOverviewComponent],
    exports: [CartOverviewComponent]
})
export class CartOverviewModule {
}
